export default __webpack_public_path__ + "static/ht-3dced45149507626f01163e920431321.svg";